import * as React from 'react';
import { ReactElement } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const InputSeparator = (props: InputSeparatorProps) => {
    const { title } = props;

    return  (
        <Root>
            <Typography
                variant="h6"
            >
                <span dangerouslySetInnerHTML={{ __html: title }} />
            </Typography>
        </Root>
    );
};

const PREFIX = 'InputSeparatorContainer';

const Root = styled('div', {
    name: PREFIX,
    overridesResolver: (props, styles) => styles.root 
})(({ theme }) => ({
    borderBottom: '2px solid',
    width: '100%',
    borderColor: theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    marginTop: '30px',
    marginBottom: '20px'
}));

export interface InputSeparatorProps {
    title?: string;
}
